var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"search-list"},_vm._l((_vm.listData),function(item,index){return _c('li',{key:index,staticClass:"search-list__item",on:{"click":function($event){return _vm.eventClick($event.target, item)}}},[_vm._v(" "+_vm._s(item.name)+", "+_vm._s(item.state)+", "+_vm._s(item.country)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }